<template>
  <Catalog
    title="Город"
    name-label="Название города"
    submit-error="Укажите название города."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "TownCatalog",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getTownById(id);
    },
    async putData(data) {
      return await this.putTown(data)
    },
    async postData(data) {
      return await this.postTown(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Towns/TownCatalog.vue